/** Parse free-text duration like "55", "45m", "1h 30m" into minutes. */
export function parseDurationInput(value: string): number | null {
  const t = value.trim().toLowerCase();
  if (!t) return null;

  const hoursMinutes = t.match(/^(\d+)\s*h(?:\s*(\d+)\s*m?)?$/);
  if (hoursMinutes) {
    const hours = parseInt(hoursMinutes[1], 10);
    const mins = parseInt(hoursMinutes[2] || '0', 10);
    if (!Number.isNaN(hours) && !Number.isNaN(mins)) {
      return hours * 60 + mins;
    }
  }

  const minutesOnly = t.match(/^(\d+)\s*m?$/);
  if (minutesOnly) {
    const mins = parseInt(minutesOnly[1], 10);
    return Number.isNaN(mins) ? null : mins;
  }

  const plain = parseInt(t, 10);
  return Number.isNaN(plain) || plain <= 0 ? null : plain;
}
